// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2x0oq{width:100%}._3_uq2{display:-ms-flexbox;display:flex;-ms-flex-item-align:center;align-self:center;color:#595757;font-size:14px;font-weight:300;line-height:23px;font-family:var(--base-font)}@media(max-width:767px){._3_uq2{font-size:16px;line-height:26px}}._3_uq2 ._1WEtQ{margin-right:auto}._3_uq2 ._35kNd{margin-left:auto}._2_vpX{height:4px;height:.25rem;background-color:#dcdddd;position:relative;overflow:hidden}.CtKea,._2_vpX{border-radius:.25rem}.CtKea{display:inline-block;height:100%;background-color:#0373f9;position:absolute;left:0;top:0}._1ay_J{background-color:#00d8ae}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "_2x0oq",
	"status": "_3_uq2",
	"start": "_1WEtQ",
	"end": "_35kNd",
	"progressBody": "_2_vpX",
	"bar": "CtKea",
	"completed": "_1ay_J"
};
module.exports = exports;
